import React from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { signupStyles } from '../../signup-templates/signup.styles';
import { AiFillCheckCircle } from 'react-icons/ai';
import { useForm } from 'react-hook-form';
import { cardPreferenceSchema, TCardPreference } from './card-preference.validator';
import { zodResolver } from '@hookform/resolvers/zod';
import { PaymentProps } from '../../templates';
import { PaymentPages } from '@/core/constants/registration-pages/registration-pages';
import useProductPrice from '@/hooks/product/useProductPrice';

const CardPreferenceForm = ({ next }: { next: PaymentProps['next'] }) => {
   const { price } = useProductPrice();
   const options: { id: TCardPreference['selectedOption']; label: string; icon: string }[] = [
      {
         id: 'card',
         label: `Pay £${price}`,
         icon: '/assets/icons/pay_icon.svg',
      },
      // { id: 'free', label: 'Get your Cancard for free', icon: '/assets/icons/id_icon.svg' },
   ];

   const {
      watch,
      setValue,
      formState: { errors, isSubmitting },
      reset,
      handleSubmit,
   } = useForm<TCardPreference>({
      defaultValues: { selectedOption: 'card' },
      resolver: zodResolver(cardPreferenceSchema),
      mode: 'onChange',
   });

   const selectedOption = watch('selectedOption');

   const onSubmit = handleSubmit(async values => {
      if (values.selectedOption === 'free') {
         console.log(values);
      }

      next(PaymentPages.PAYMENT);
   });

   return (
      <Box as="form" css={signupStyles.signup_form} onSubmit={onSubmit}>
         <Flex justify="center" gap={6}>
            {options.map(option => (
               <Box
                  key={option.id}
                  cursor="pointer"
                  borderRadius="12px"
                  w="150px"
                  h="110px"
                  p="4"
                  pt="6"
                  display="flex"
                  alignItems="center"
                  justifyContent="start"
                  flexDirection="column"
                  position="relative"
                  mb="8"
                  textAlign="center"
                  transition="all 0.3s ease-in-out"
                  borderWidth="2px"
                  borderColor={selectedOption === option.id ? 'yellow.400' : 'gray.600'}
                  bg="gray.800"
                  onClick={() => setValue('selectedOption', option.id)}
               >
                  <Image src={option.icon} alt={option.label} width={50} height={26} style={{ width: 'auto' }} />
                  <Text color="white" fontWeight="600" mt="2" textStyle="xs">
                     {option.label}
                  </Text>

                  {selectedOption === option.id && (
                     <Box position="absolute" top="8px" right="8px" borderRadius="full" color="brand" textStyle="xl">
                        <AiFillCheckCircle />
                     </Box>
                  )}
               </Box>
            ))}
         </Flex>
         {errors.selectedOption && (
            <Text color="error" textAlign="center" pb={4}>
               {errors.selectedOption.message}
            </Text>
         )}
         <Box css={signupStyles.signup_btn_con}>
            <Button
               type="reset"
               onClick={() => reset()}
               bg="darkerBtn"
               textStyle="xs"
               color="white"
               h="10"
               maxW="36"
               minW="36"
               p="0"
            >
               Reset
            </Button>
            <Button type="submit" disabled={isSubmitting} textStyle="xs" h="10" maxW="36" minW="36" p="0">
               Continue
            </Button>
         </Box>
      </Box>
   );
};

export default CardPreferenceForm;
